export default __webpack_public_path__ + "static/media/freedoom1-1024.0783d370.png";